var prefix = 'page-header';
export var dataHooks = {
  breadcrumbs: "".concat(prefix, "-breadcrumbs"),
  backButton: "".concat(prefix, "-backbutton"),
  title: "".concat(prefix, "-title"),
  subtitle: "".concat(prefix, "-subtitle"),
  actionBar: "".concat(prefix, "-actionbar")
};